import { getCompressedAssetUrl } from 'lib/config/assetUrls';

const PL_LANDING = '/web_v2/performance-lab/landing-page/hero/videos';

const HERO_BACKGROUND_DESKTOP = `${PL_LANDING}/full-prev_v2.mp4`;
const HERO_BACKGROUND_MOBILE = `${PL_LANDING}/min-prev_v2.mp4`;
const HERO_MODAL_DESKTOP = `${PL_LANDING}/full-wide-v2.mp4`;
const HERO_MODAL_MOBILE = `${PL_LANDING}/full-min-v2.mp4`;

export const PERFORMANCE_LAB_HERO_VIDEO = {
  base: HERO_BACKGROUND_DESKTOP,
  desktop: getCompressedAssetUrl(`${HERO_BACKGROUND_DESKTOP}/w_1920`),
  mobile: getCompressedAssetUrl(`${HERO_BACKGROUND_MOBILE}/w_1080`),
  mobileFallback: getCompressedAssetUrl(`${HERO_BACKGROUND_MOBILE}/w_1080`),
};

export const PERFORMANCE_LAB_HERO_MODAL_VIDEO = {
  base: HERO_MODAL_DESKTOP,
  desktop: getCompressedAssetUrl(`${HERO_MODAL_DESKTOP}`),
  mobile: getCompressedAssetUrl(`${HERO_MODAL_MOBILE}`),
};

const PL_RECOVERY_HERO = '/web_v2/performance-lab/recovery-page/hero';

const RECOVERY_HERO_BACKGROUND_DESKTOP = `${PL_RECOVERY_HERO}/hero-full.mp4`;
const RECOVERY_HERO_BACKGROUND_MOBILE = `${PL_RECOVERY_HERO}/hero-min.mp4`;

export const PERFORMANCE_LAB_RECOVERY_HERO_VIDEO = {
  base: RECOVERY_HERO_BACKGROUND_DESKTOP,
  desktop: getCompressedAssetUrl(`${RECOVERY_HERO_BACKGROUND_DESKTOP}/w_1920`),
  mobile: getCompressedAssetUrl(`${RECOVERY_HERO_BACKGROUND_MOBILE}/w_1080`),
  mobileFallback: getCompressedAssetUrl(
    `${RECOVERY_HERO_BACKGROUND_MOBILE}/w_1080`,
  ),
};
